



































import Vue from 'vue';
import api from '@/common/api';
import LoadingModal from '@/common/components/LoadingModal.vue';
import { mapGetters } from 'vuex';
import MerchantLogoPicker from './MerchantLogoPicker.vue';

export default Vue.extend({
  data() {
    return {
      isSubmitting: false as boolean,
      logo: '',
    };
  },
  mounted() {
    this.loadMerchantLogo();
  },
  computed: {
    ...mapGetters(['branding']),
  },
  methods: {
    submitActions(isSubmitting: boolean) {
      this.isSubmitting = isSubmitting;
    },
    loadMerchantLogo() {
      if (this.$refs.loader) {
        (this.$refs.loader as any).setLoading();
      }
      api.get('merchant/logo').then((response) => {
        this.logo = response.data.data!.logo;
      }).catch(this.handleLoadingError);
    },
    handleLoadingError() {
      this.$toasted.error('Merchant Logo not found');
    },
    save() {
      this.submitActions(true);
      api
        .put(`/merchant/logo/${this.branding.merchantId}`, { logo: this.logo })
        .then(() => {
          this.showSuccess();
        })
        .catch(this.handleSaveError);
    },
    showSuccess() {
      this.submitActions(false);
      this.$toasted.success('Merchant Logo updated successfully!');
    },
    handleSaveError({ response }: { response: any }) {
      this.submitActions(false);
      if (response.status === 422) {
        let msg: any = '';
        if (response?.data?.errors) {
          const errors = response?.data?.errors;
          Object.keys(errors).forEach((key: any, idx: any) => {
            if (idx > 0) msg += '<br />';
            msg += `${errors[key]}`;
          });
        } else if (response?.data?.message) {
          msg += response?.data?.message;
        }
        if (msg) this.$toasted.error(msg);
        else this.$toasted.error(`There was a problem saving the merchant logo. (${response.status})`);
      } else {
        this.$toasted.error(`There was a problem saving the merchant logo. (${response.status})`);
      }
    },
    updateLogo(logo: string) {
      this.logo = logo;
    },
  },
  components: {
    MerchantLogoPicker,
    LoadingModal,
  },
});
